var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { getConfig } from "@jti/fe-common";
import { magento } from "../../../client/getClient";
const pdpMappingCache = {};
export function prepareProductLink(sku) {
    return __awaiter(this, void 0, void 0, function* () {
        var _a, _b, _c;
        if (pdpMappingCache[sku]) {
            return pdpMappingCache[sku];
        }
        const { SHOP_URL } = getConfig();
        const response = yield magento.getUrlKeys(sku);
        const product = (_b = (_a = response === null || response === void 0 ? void 0 : response.products) === null || _a === void 0 ? void 0 : _a.items) === null || _b === void 0 ? void 0 : _b[0];
        if (!product) {
            return "";
        }
        const productUrlKey = product.url_key;
        const category = (_c = product.categories) === null || _c === void 0 ? void 0 : _c[0];
        if (!category) {
            return "";
        }
        const categoryUrlKey = category === null || category === void 0 ? void 0 : category.url_path;
        const pdpUrl = `${SHOP_URL}/${categoryUrlKey}/${productUrlKey}`;
        pdpMappingCache[sku] = pdpUrl;
        return pdpUrl;
    });
}
//# sourceMappingURL=prepareProductLink.js.map